import * as React from 'react';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { Catalog } from '../hooks/useSelectFormality';

export type SearchChipsProps = {
    catalogs: Array<Pick<Catalog, 'id' | 'label'>>;
    uncheckCatalog: (catalogId: number) => void;
};

const SearchChips: React.FunctionComponent<SearchChipsProps> = function (props) {
    const { catalogs, uncheckCatalog } = props;
    const { palette } = useTheme();

    const token = palette.chip?.primary;

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '4px 15px' }}>
            {catalogs.map((catalog) => (
                <Button
                    sx={{
                        width: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '2px 8px',
                        gap: '0 5px',
                        color: token?.textColor,
                        backgroundColor: token?.backgroundColor,
                        '&:hover': {
                            color: token?.textColorOnHover,
                            backgroundColor: token?.backgroundColorOnHover,
                        },
                    }}
                    key={`chip-${catalog.id}`}
                    onClick={() => {
                        uncheckCatalog(catalog.id);
                    }}
                >
                    <Typography variant="l2dcaption">{catalog.label}</Typography>
                    <FaOptionIcon
                        sx={{
                            color: token?.textColor,
                            '&:hover': {
                                color: token?.textColorOnHover,
                            },
                            fontSize: '10px',
                        }}
                        icon="times"
                    />
                </Button>
            ))}
        </Box>
    );
};

export default SearchChips;
